<div id="chat-container" class="tw-flex tw-flex-col tw-h-full chat-container">
  <!-- Centered chat content area -->
  <div
    #chatScrollContainer
    class="tw-flex-1 tw-overflow-y-auto tw-flex tw-flex-col tw-items-center">
    <div class="tw-box-border tw-w-full sm:tw-w-11/12 tw-max-w-3xl tw-px-3 sm:tw-px-4 tw-py-4 sm:tw-py-6">
      <!-- chat messages -->
      <ng-container *ngFor="let message of messages; let i = index; trackBy: trackByMessageIndex">
      <div
        *ngIf="shouldDisplayMessage(message, i)"
        class="tw-flex tw-gap-2 sm:tw-gap-3"
        [ngClass]="{'tw-justify-end': message.role === 'user',
                      'tw-justify-start': message.role === 'assistant'}">
        <!-- robot face -->
        <img
          *ngIf="message.role === 'assistant'"
          src="../../../assets/img/ldt-robot.svg"
          alt="robot face"
          class="tw-w-6 sm:tw-w-7 tw-self-start tw-shrink-0 ldt-logo-white-gray tw-mt-2" />

        <div *ngIf="message.role !== 'thinking'" class="tw-my-2 sm:tw-my-4 tw-flex-1 tw-max-w-[95%] sm:tw-max-w-[85%]">
          <!-- Collapsed thinking bubble for completed thinking (shows before assistant messages) -->
          <div
            *ngIf="message.role === 'assistant' && hasThinkingMessagesBeforeAssistant(i)"
            class="tw-mb-3">
            <div
              (click)="toggleThinkingExpanded(i)"
              class="tw-bg-purple-50 dark:tw-bg-purple-900/20 tw-border tw-border-purple-200 dark:tw-border-purple-800 tw-rounded-lg tw-px-4 tw-py-2 tw-cursor-pointer hover:tw-bg-purple-100 dark:hover:tw-bg-purple-900/30 tw-transition-colors">
              <div class="tw-flex tw-items-center tw-gap-2">
                <mat-icon
                  class="tw-text-purple-500 dark:tw-text-purple-400 tw-text-[18px] tw-w-[18px] tw-h-[18px]">
                  {{ isThinkingExpanded(i) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
                <mat-icon
                  class="tw-text-purple-500 dark:tw-text-purple-400 tw-text-[18px] tw-w-[18px] tw-h-[18px]">
                  psychology
                </mat-icon>
                <span class="tw-text-sm tw-font-medium tw-text-purple-700 dark:tw-text-purple-300">
                  AI Thinking ({{ getThinkingMessagesBeforeAssistant(i).length }} steps)
                </span>
              </div>

              <!-- Expanded thinking content -->
              <div *ngIf="isThinkingExpanded(i)" class="tw-mt-3 tw-space-y-2">
                <div
                  *ngFor="let thinkingMsg of getThinkingMessagesBeforeAssistant(i)"
                  class="tw-flex tw-items-start tw-gap-2 tw-text-sm tw-text-purple-600 dark:tw-text-purple-400 tw-bg-white dark:tw-bg-gray-800 tw-rounded tw-px-3 tw-py-2">
                  <mat-icon
                    class="tw-text-[16px] tw-w-[16px] tw-h-[16px] tw-mt-0.5 tw-flex-shrink-0"
                    >check</mat-icon
                  >
                  <span class="tw-flex-1">{{ thinkingMsg.text }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            [ngClass]="{
                'tw-bg-blue-100 dark:tw-bg-blue-900': message.role === 'user',
                'tw-bg-white dark:tw-bg-gray-800': message.role === 'assistant'
              }"
            class="tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-700 tw-p-3 sm:tw-p-4 tw-rounded-2xl">
            <!-- Message content -->
            <div
              class="tw-whitespace-pre-wrap tw-break-words tw-text-gray-900 dark:tw-text-gray-200"
              [ngClass]="{'tw-text-base': message.role === 'user'}">
              <!-- User messages -->
              <div *ngIf="message.role === 'user'">
                <!-- Normal display mode -->
                <div *ngIf="editingMessageIndex !== i" class="tw-group tw-relative">
                  <span>{{message.text}}</span>
                  <!-- Edit button (only for messages with message_id) -->
                  <button
                    *ngIf="message.message_id && !isLoading && !isSharedThread"
                    mat-icon-button
                    class="tw-absolute tw-top-[-8px] tw-right-[-8px] tw-w-7 tw-h-7 tw-min-w-0 tw-p-0 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-bg-blue-200 dark:tw-bg-blue-800 tw-rounded-full"
                    (click)="startEditingMessage(i)"
                    matTooltip="Edit and re-run"
                    aria-label="Edit and re-run">
                    <mat-icon class="tw-text-[16px] tw-w-[16px] tw-h-[16px]">edit</mat-icon>
                  </button>
                </div>
                <!-- Edit mode -->
                <div *ngIf="editingMessageIndex === i" class="tw-flex tw-flex-col tw-gap-2">
                  <textarea
                    [(ngModel)]="editingMessageText"
                    class="tw-w-full tw-text-sm tw-p-2 tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded tw-bg-white dark:tw-bg-gray-700 tw-text-gray-900 dark:tw-text-white tw-resize-none"
                    rows="3"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="8"></textarea>
                  <div class="tw-flex tw-justify-end tw-gap-2">
                    <button mat-button class="tw-text-sm tw-h-8" (click)="cancelEditing()">
                      Cancel
                    </button>
                    <button
                      mat-flat-button
                      color="primary"
                      class="tw-text-sm tw-h-8"
                      [disabled]="!editingMessageText.trim()"
                      (click)="submitEdit()">
                      Submit
                    </button>
                  </div>
                </div>
              </div>

              <!-- Basic message format -->
              <div *ngIf="message.role === 'assistant' && !message.sections && message.text">
                <markdown [data]="message.text" class="markdown-content"></markdown>
              </div>
            </div>

            <!-- Feedback and actions below assistant messages -->
            <div *ngIf="message.role === 'assistant'">
              <div
                *ngIf="!message.isLoading && !isSharedThread"
                class="tw-relative tw-h-1">
                <!-- Artifact generating: replace thumbs with spinner pill on last assistant message -->
                <div
                  *ngIf="isArtifactPending && isLastAssistantMessage(i)"
                  class="tw-border-gray-700 tw-border-solid tw-border tw-absolute tw-right-[-8px] tw-flex tw-items-center tw-gap-2 tw-bg-white dark:tw-bg-gray-800 tw-shadow tw-rounded-lg tw-px-2.5 tw-py-1.5">
                  <mat-spinner diameter="14"></mat-spinner>
                  <span
                    class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-whitespace-nowrap tw-pr-1"
                    >Generating artifacts...</span
                  >
                </div>

                <!-- Per-message feedback + actions -->
                <div
                  *ngIf="!(isArtifactPending && isLastAssistantMessage(i))"
                  class="tw-border-gray-700 tw-border-solid tw-border tw-absolute tw-right-[-8px] tw-flex tw-items-center tw-gap-1 tw-bg-white dark:tw-bg-gray-800 tw-shadow tw-rounded-lg tw-px-1.5 tw-py-1">
                  <!-- Thumbs up -->
                  <button
                    mat-icon-button
                    class="tw-w-7 tw-h-7 tw-min-w-0 tw-p-0.5"
                    [ngClass]="messageFeedback[message.message_id] === true ? 'tw-text-primary_purple-500' : 'tw-text-gray-500 dark:tw-text-gray-300 hover:tw-text-gray-600 dark:hover:tw-text-gray-100'"
                    (click)="message.message_id ? messageQuickFeedback(message, true) : quickFeedback(true)"
                    matTooltip="This was helpful">
                    <div class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                      <mat-icon class="tw-text-[18px]">thumb_up</mat-icon>
                    </div>
                  </button>
                  <!-- Thumbs down -->
                  <button
                    mat-icon-button
                    class="tw-w-7 tw-h-7 tw-min-w-0 tw-p-0.5"
                    [ngClass]="messageFeedback[message.message_id] === false ? 'tw-text-orange-500' : 'tw-text-gray-500 dark:tw-text-gray-300 hover:tw-text-gray-600 dark:hover:tw-text-gray-100'"
                    (click)="message.message_id ? messageQuickFeedback(message, false) : quickFeedback(false)"
                    matTooltip="This needs improvement">
                    <div class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                      <mat-icon class="tw-text-[18px]">thumb_down</mat-icon>
                    </div>
                  </button>
                  <!-- Divider -->
                  <div
                    *ngIf="message.message_id"
                    class="tw-w-px tw-h-5 tw-bg-gray-300 dark:tw-bg-gray-600 tw-mx-0.5"></div>
                  <!-- Branch from here -->
                  <mat-spinner
                    *ngIf="message.message_id && branchingMessageId === message.message_id"
                    diameter="14"
                    class="tw-mx-1.5"></mat-spinner>
                  <button
                    *ngIf="message.message_id && branchingMessageId !== message.message_id"
                    mat-icon-button
                    class="tw-w-7 tw-h-7 tw-min-w-0 tw-p-0.5 tw-text-gray-500 dark:tw-text-gray-300 hover:tw-text-gray-600 dark:hover:tw-text-gray-100"
                    [disabled]="isLoading || branchingMessageId"
                    (click)="branchFromMessage(message)"
                    [matTooltip]="isLoading ? 'Wait for response to finish' : 'Branch conversation from here'"
                    [attr.aria-label]="isLoading ? 'Wait for response to finish' : 'Branch conversation from here'">
                    <div class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                      <mat-icon class="tw-text-[18px]">fork_right</mat-icon>
                    </div>
                  </button>
                </div>

                <!-- Inline feedback input -->
                <div
                  *ngIf="showFeedbackInput && (feedbackMessageId === message.message_id || (!feedbackMessageId && messages.length === i + 1))"
                  class="tw-absolute tw-right-[-8px] tw-bottom-[24px] tw-bg-white dark:tw-bg-gray-800 tw-rounded-lg tw-border-1 tw-border-gray-200 tw-border-solid dark:tw-border-gray-600 tw-shadow-lg dark:tw-shadow-gray-600 tw-w-[calc(100vw-3rem)] sm:tw-w-80 tw-max-w-80 tw-pb-1">
                  <!-- Status banner -->
                  <div
                    class="dark:tw-bg-gray-800 tw-rounded-t-lg tw-px-4 tw-py-2 tw-pt-3 tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
                    <h3 class="tw-text-base tw-font-semibold tw-text-primary_purple-500 tw-my-1">
                      Your rating has been submitted. Feedback is appreciated.
                    </h3>
                  </div>
                  <div class="tw-py-2 tw-pb-1 tw-px-4">
                    <div class="tw-box-border">
                      <textarea
                        [(ngModel)]="feedbackText"
                        [placeholder]="feedbackPlaceholder"
                        class="tw-box-border tw-w-full tw-text-sm tw-p-2 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-gray-900 dark:tw-text-white dark:tw-placeholder-gray-300"
                        rows="3">
                      </textarea>
                    </div>
                    <div class="tw-flex tw-justify-end tw-gap-2 tw-mt-1">
                      <button
                        mat-button
                        class="tw-text-sm tw-h-10"
                        (click)="showFeedbackInput = false; feedbackMessageId = null">
                        Cancel
                      </button>
                      <button
                        mat-button
                        color="primary"
                        class="tw-text-sm tw-font-semibold tw-h-10"
                        (click)="submitFeedback()">
                        Submit
                      </button>
                    </div>
                  </div>
                  <div
                    class="tw-absolute tw-bottom-[-6px] tw-right-5 tw-w-3 tw-h-3 tw-rotate-45 tw-bg-white dark:tw-bg-gray-800 tw-border-b tw-border-r tw-border-gray-200 dark:tw-border-gray-600"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-container>

      <!-- Stopped indicator when thread was cancelled (not a clarification interrupt) -->
      <div
        *ngIf="wasCancelled && !isLoading"
        class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-3 tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
        <mat-icon class="tw-text-[16px] tw-w-[16px] tw-h-[16px]">stop_circle</mat-icon>
        <span>Response was stopped</span>
      </div>

      <!-- Loading spinner when thread is first loading -->
      <div
        *ngIf="isLoading && messages.length === 0"
        class="tw-flex tw-justify-center tw-items-center tw-py-12">
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
          <mat-spinner diameter="40"></mat-spinner>
          <span class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">Loading thread...</span>
        </div>
      </div>

      <!-- AI Thinking bubble (at bottom) - suppressed when artifact is generating -->
      <div *ngIf="isThinkingInProgress() && !isArtifactPending">
        <div class="tw-flex tw-gap-2 sm:tw-gap-3 tw-mt-4 tw-mb-2 tw-justify-start">
          <!-- robot face -->
          <img
            src="../../../assets/img/ldt-robot.svg"
            alt="robot face"
            class="tw-w-6 sm:tw-w-7 tw-self-start tw-shrink-0 ldt-logo-white-gray tw-mt-2" />

          <div class="tw-flex-1 tw-max-w-[95%] sm:tw-max-w-[85%]">
            <div
              class="tw-relative tw-overflow-hidden tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-solid tw-border-gray-200 dark:tw-border-[#27272a] tw-py-3 tw-px-3 sm:tw-py-4 sm:tw-px-4 tw-rounded-2xl thinking-bubble">
              <!-- Thinking header -->
              <div class="tw-flex tw-items-center tw-gap-2 tw-mb-3">
                <mat-icon class="tw-text-purple-500 thinking-icon">psychology</mat-icon>
                <span class="tw-font-medium tw-text-gray-900 dark:tw-text-gray-200"
                  >AI is thinking...</span
                >
              </div>

              <!-- Thinking steps -->
              <div
                *ngFor="let thinkingMsg of getActiveThinkingMessages()"
                class="tw-flex tw-items-start tw-gap-2 tw-mb-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">
                <mat-icon class="tw-text-[16px] tw-w-[16px] tw-h-[16px] tw-mt-0.5"
                  >chevron_right</mat-icon
                >
                <span class="tw-flex-1">{{ thinkingMsg.text }}</span>
              </div>

              <!-- Cancel and Notify row -->
              <div
                class="tw-flex tw-items-center tw-justify-between tw-mt-4 tw-pt-3 tw-border-t tw-border-gray-200 dark:tw-border-gray-700">
                <!-- Cancel button -->
                <button
                  *ngIf="!isSharedThread"
                  mat-stroked-button
                  class="tw-text-sm tw-h-8"
                  [disabled]="isCancelling"
                  (click)="cancelRun()">
                  <mat-icon class="tw-text-[16px] tw-mr-1" *ngIf="!isCancelling">stop</mat-icon>
                  <mat-spinner *ngIf="isCancelling" diameter="14" class="tw-mr-1 tw-inline-block"></mat-spinner>
                  Stop
                </button>
                <div *ngIf="isSharedThread"></div>

                <!-- Notify toggle -->
                <div
                  *ngIf="notificationsSupported"
                  class="tw-flex tw-items-center tw-gap-2">
                  <div class="tw-flex tw-items-center tw-gap-1">
                    <mat-icon
                      class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-text-gray-600 dark:tw-text-gray-500">
                      notifications
                    </mat-icon>
                    <span class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-500">
                      Notify when ready
                    </span>
                  </div>
                  <mat-slide-toggle
                    [(ngModel)]="notifyWhenDone"
                    (change)="toggleNotifyWhenDone($event.checked)"
                    color="primary"
                    class="tw-text-sm">
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-500 tw-pl-10 sm:tw-pl-14"
          >The AI can take up to 3 minutes to finish its answer...</span
        >
      </div>
    </div>
  </div>

  <!-- Fixed bottom input area (hidden when initially loading, thread is busy, artifact is generating, or shared thread) -->
  <div
    *ngIf="!(isLoading && messages.length === 0) && chatResponse?.status !== 'busy' && !isArtifactPending && !isSharedThread"
    class="tw-border-t tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-900 tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-flex tw-items-center tw-justify-center">
    <div class="tw-w-full tw-max-w-3xl tw-mx-auto">
      <div class="tw-relative">
        <mat-form-field appearance="outline" floatLabel="auto" class="tw-w-full nc-rounded-input">
          <mat-label class="dark:tw-text-white"> Ask a follow-up question... </mat-label>
          <textarea
            matInput
            [(ngModel)]="currentPrompt"
            [disabled]="isLoading"
            rows="1"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="8"
            class="dark:tw-text-gray-200 tw-resize-none tw-pr-12"
            (keydown.enter)="!$event.shiftKey && sendMessage(); !$event.shiftKey && $event.preventDefault()">
          </textarea>
        </mat-form-field>
        <button
          mat-icon-button
          (click)="sendMessage()"
          [disabled]="isLoading || !currentPrompt?.trim()"
          class="tw-absolute tw-right-3 tw-bottom-8 tw-w-8 tw-h-8 tw-min-w-0 tw-bg-gray-800 dark:tw-bg-gray-200 tw-text-white dark:tw-text-gray-900 hover:tw-bg-gray-700 dark:hover:tw-bg-gray-300 tw-rounded-lg disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-flex tw-items-center tw-justify-center"
          matTooltip="Send">
          <mat-icon
            class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-leading-[18px] tw-overflow-visible"
            >arrow_upward</mat-icon
          >
        </button>
      </div>
    </div>
  </div>
</div>
